import { render, staticRenderFns } from "./ModalPayCharge.vue?vue&type=template&id=1b8706e6"
import script from "./ModalPayCharge.vue?vue&type=script&lang=js"
export * from "./ModalPayCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports